import { Button, Container, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

const HeroSection = ({
  title,
  subtitle,
  description,
  primaryButtonText,
  primaryButtonLink,
  backgroundImage,
}) => {
  return (
    <div
      className="relative text-white overflow-hidden"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '75vh',
      }}
    >
      {/* Dark Overlay for readability */}
      <div
        className="absolute inset-0 bg-black/50"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      />

      <Container
        maxWidth="lg"
        className="!flex !justify-center !items-center py-16 sm:py-32 px-4 sm:px-8 relative z-10 h-full min-h-[75vh]"
      >
        <div className="text-center max-w-4xl w-full">
          <Typography
            variant="h1"
            component="h1"
            className="mb-6 sm:mb-8 drop-shadow-lg text-white !text-3xl sm:!text-5xl md:!text-6xl"
            style={{ fontWeight: 800, textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}
          >
            {title}
          </Typography>
          <Typography
            variant="h4"
            component="p"
            className="mb-8 sm:mb-10 opacity-95 text-white !text-xl sm:!text-2xl md:!text-3xl"
            style={{ fontWeight: 600, textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}
          >
            {subtitle}
          </Typography>
          <div className="max-w-xl mx-auto">
            <Typography
              variant="body1"
              className="!text-base sm:!text-xl leading-relaxed opacity-95 mb-8 sm:mb-10 text-white text-center"
              style={{
                fontWeight: 400,
                textAlign: 'center',
                textShadow: '0 1px 2px rgba(0,0,0,0.3)',
              }}
            >
              {description}
            </Typography>
          </div>
          <div className="flex justify-center mt-8">
            {primaryButtonText && primaryButtonLink && (
              <Button
                component={Link}
                to={primaryButtonLink}
                variant="contained"
                size="large"
                className="px-8 py-3 !text-lg !font-bold !bg-[#063447] !text-white hover:bg-stone-100 shadow-xl transform transition hover:-translate-y-1"
              >
                {primaryButtonText}
              </Button>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeroSection;
